const about = {
  title: "关于华丽的外出",
  subtitle: "让每一次外出都成为令人难忘的时尚时刻",
  brandIntro: "品牌介绍",
  brandDesc: "「华丽的外出」诞生于对美好生活的无限热爱。我们相信，每一次出门都是一次展示自我的机会——无论是精致的约会、热闹的派对，还是平凡的日常通勤，都值得你用最好的状态去迎接。",
  brandMission: "我们的使命是帮助每一位追求品质生活的你，从穿搭到妆容，从配饰到仪态，全方位提升出行风格。通过专业的穿搭攻略、实用的造型技巧和前沿的时尚资讯，让你在任何场合都能自信绽放，散发独特魅力。",
  reputationTitle: "品牌口碑",
  reputationSubtitle: "来自读者的真实反馈",
  contactTitle: "联系我们",
  contactSubtitle: "有任何问题或合作意向，欢迎随时与我们联系",
  contactInfo: "联系方式",
  email: "电子邮箱",
  emailValue: "contact@hualidewaichu.com",
  wechat: "微信公众号",
  wechatValue: "华丽的外出",
  xiaohongshu: "小红书",
  xiaohongshuValue: "华丽的外出",
  workingHours: "工作时间",
  workingHoursValue: "周一至周五 9:00 - 18:00",
  formName: "姓名",
  formNamePlaceholder: "请输入您的姓名",
  formEmail: "邮箱",
  formEmailPlaceholder: "请输入您的邮箱",
  formMessage: "留言内容",
  formMessagePlaceholder: "请输入您想说的内容（不超过500字）",
  formSubmit: "发送留言",
  formSuccess: "感谢您的留言！我们会在24小时内回复您。",
  formError: "发送失败，请稍后重试。",
  breadcrumbHome: "首页",
  breadcrumbAbout: "关于我们",
  milestones: "品牌历程",
};

export default about;